module.exports = __webpack_public_path__ + "static/media/artunity-map-sketch.cfb15df9.jpg";